<template>
  <v-container fluid>
    <v-layout row>
      <v-flex shrink pa-1>
        <v-card color="black" dark>
          <section class="cropper-area">
            <v-layout class="img-cropper" align-center>
              <vue-cropper
                v-if="!!imgSrc"
                ref="cropper"
                :aspect-ratio="1 / Math.sqrt(2)"
                :src="imgSrc"
                preview=".preview"
              />
            </v-layout>
            <v-btn-toggle multiple class="actions d-inline-flex">
              <v-btn class="reset" fab dark color="light-blue" @click="zoom(0.2)">
                <v-icon dark>zoom_in</v-icon>
              </v-btn>
              <v-btn class="reset" fab dark color="light-blue" @click="zoom(-0.2)">
                <v-icon dark>zoom_out</v-icon>
              </v-btn>
              <v-btn class="reset" fab dark color="cyan" @click="move(-10, 0)">
                <v-icon dark>arrow_back</v-icon>
              </v-btn>
              <v-btn class="reset" fab dark color="cyan" @click="move(0, -10)">
                <v-icon dark>arrow_upward</v-icon>
              </v-btn>
              <v-btn class="reset" fab dark color="cyan" @click="move(0, 10)">
                <v-icon dark>arrow_downward</v-icon>
              </v-btn>
              <v-btn class="reset" fab dark color="cyan" @click="move(10, 0)">
                <v-icon dark>arrow_forward</v-icon>
              </v-btn>
              <v-btn class="reset" fab dark color="teal" @click="reset">
                <v-icon dark>restart_alt</v-icon>
              </v-btn>
            </v-btn-toggle>
          </section>
        </v-card>
      </v-flex>
      <v-flex grow pa-1>
        <!-- <v-layout row wrap>
          <v-flex d-flex> -->
            <v-card color="black" dark>
              <section class="preview-area">
                <!-- <p>Previsualización</p> -->
                <div class="preview" />
                <v-btn-toggle multiple class="actions d-inline-flex">
                  <v-btn class="printer" fab dark color="red" @click="printImage">
                    <v-icon dark>print</v-icon>
                  </v-btn>
                </v-btn-toggle>
                <!-- <p>Cropped Image</p> -->
                <div class="cropped-image printable d-none">
                  <img
                    v-if="cropImg"
                    :src="cropImg"
                    alt="Cropped Image"
                  />
                  <div v-else class="crop-placeholder" />
                </div>
              </section>
            </v-card>
          <!-- </v-flex>
        </v-layout> -->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import { Printd } from 'printd'

var configBaseAxios = {
  timeout: 10000,
  withCredentials: true,
  headers: {
    Accept: "application/json",
    "Content-Type": "x-www-form-urlencoded",
  },
  params: {},
};
export default {
  components: { VueCropper },
  mounted() {
    this.logged_user = JSON.parse(localStorage.getItem("logged_user"));
    Promise.all([this.getArchivos()])
      .then(() => {
        // console.log('promesa lista')
        // this.viewImage()
        // this.$refs.cropper.replace(this.imgSrc);

        // this.cropper = new Cropper(this.image, {
        //   crop: () => {
        //     const canvas = this.cropper.getCroppedCanvas()
        //     this.$emit('crop', canvas.toDataURL('image/png'))
        //   }
        // })
      })
      .catch((reason) => {
        console.log("Fail", reason);
        //setTimeout(()=>{ bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" }); }, 1000)
      });

    this.getArchivos()
  },
  data() {
    return {
      pagename: "Visor de Imagenes",
      logged_user: null,
      archivos: [],
      images: [],
      image: {},
      cropper: {},
      imgSrc: null,//'/img/berserk.jpeg',
      cropImg: '',
      data: null,
    };
  },
  methods: {
    getArchivos() {
      return new Promise((resolve, reject) => {
        configBaseAxios.params = {
          accion: "archivos",
          opcion: "listarArchivo",
          id_examen: this.$route.params.id_examen,
          api_token: this.logged_user.api_token,
        };
        axios
          .create(configBaseAxios)
          .get(window.base_path + window.ws)
          .then((result) => {
            if (result.data.response) {
              this.archivos = result.data.callback.filter(
                (images) => images.tipo == this.$route.params.type
              );
              this.imgSrc =
                window.base_path +
                window.filesDCM +
                this.archivos[0].ArchivoJPG;

              // this.imgSrc =
              //   '/img/'+
              //   this.archivos[0].ArchivoJPG;
              
              // console.log(
              //   "archivos",
              //   JSON.parse(JSON.stringify(this.archivos))
              // );
              // console.log("SRC", this.imgSrc);
              resolve();
            } else {
              reject("No data result");
            }
          })
          .catch((error) => {
            reject("Error ajax");
          });
      });
    },
    printImage: function() {
      this.cropImage();
      setTimeout(() => {
        let printable = document.getElementsByClassName('printable')[0]
        const d = new Printd()
        d.print( printable )
      }, 500);
    },
    cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
    },
    flipX() {
      const dom = this.$refs.flipX;
      let scale = dom.getAttribute('data-scale');
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleX(scale);
      dom.setAttribute('data-scale', scale);
    },
    flipY() {
      const dom = this.$refs.flipY;
      let scale = dom.getAttribute('data-scale');
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleY(scale);
      dom.setAttribute('data-scale', scale);
    },
    getCropBoxData() {
      this.data = JSON.stringify(this.$refs.cropper.getCropBoxData(), null, 4);
    },
    getData() {
      this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
    },
    move(offsetX, offsetY) {
      this.$refs.cropper.move(offsetX, offsetY);
    },
    reset() {
      this.$refs.cropper.reset();
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },
    setCropBoxData() {
      if (!this.data) return;

      this.$refs.cropper.setCropBoxData(JSON.parse(this.data));
    },
    setData() {
      if (!this.data) return;

      this.$refs.cropper.setData(JSON.parse(this.data));
    },
    setImage(e) {
      const file = e.target.files[0];

      if (file.type.indexOf('image/') === -1) {
        alert('Please select an image file');
        return;
      }

      if (typeof FileReader === 'function') {
        const reader = new FileReader();

        reader.onload = (event) => {
          this.imgSrc = event.target.result;
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result);
        };

        reader.readAsDataURL(file);
      } else {
        alert('Sorry, FileReader API not supported');
      }
    },
    showFileChooser() {
      this.$refs.input.click();
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    },
  },
};
</script>

<style>
  .cropper-area .img-cropper {
    height: calc(100vh - 48px - 36px - 5px);
  }
  .cropper-area .img-cropper > div {
    border-style: dashed solid;
    border-color: white;
  }
  .actions {
    position: absolute;
    bottom: 0%;
  }
  .actions .v-btn {
    opacity: .7;
  }
  .preview-area {
    width: calc((100vh - 48px - 36px - 5px) / 1.41421356237); /*calc(50vw - 45px);*/
  }
  /* .preview-area .printer {
    position: absolute;
    bottom: 0%;
    right: 0%;
  } */
  .preview {
    width: calc((100vh - 48px - 36px - 5px) / 1.41421356237); /*100%;*/
    height: calc(100vh - 48px - 36px - 5px); /*calc((50vw - 45px) * (1 / 1.41421356237)); */
    overflow: hidden;
  }
  /* .crop-placeholder {
    width: 100%;
    height: 200px;
    background: #ccc;
  } */
  /* .cropped-image img {
    max-width: 100%;
  } */
</style>